module.exports = __webpack_public_path__ + "static/media/pencil-tip.6a138d0d.svg";